import './style/index.js';

import _Popup from './popup';

export * from './type';
export type { PopupProps } from './popup';

export const Popup = _Popup;
export default Popup;
